<template lang="pug">
el-collapse(v-model='indicesCollapseAreaPreservacaoPermanente')
    el-collapse-item(:name='`collapse-area-preservacao-permanente`')
        template(slot='title')
            span.titulo Área de preservação permanente
        .collapse-item-bloco-info
            .info
                label Áreas de preservação permanente:
                span {{ formatNumber(dados?.areaPreservacaoPermanente, 2) }}
            .info
                label Área de preservação permanente em área consolidada:
                span {{ formatNumber(dados?.areaPreservacaoPermanenteEmAreaConsolidada, 2) }}
            .info
                label Área de preservação permanente em área de remanescente em vegetação nativa:
                span {{ formatNumber(dados?.areaPreservacaoPermanenteEmAreaVegetacaoNativa, 2) }}
</template>

<script>
import formatter from '@/utils/formatters';

export default {
    name: 'CollapseAreaPreservacaoPermanente',
    props: {
        dados: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            indicesCollapseAreaPreservacaoPermanente: []
        };
    },
    methods: {
        formatNumber(number, decimalPlaces = 2) {
            if (!number) return '-';
            return formatter.formatNumber(number, decimalPlaces) + ' ha';
        }
    }
};
</script>

<style lang="scss">
.titulo {
    font-weight: bold;
}
</style>
